"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCloseButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
exports.StyledCloseButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 500;\n  top: 0;\n  right: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n  outline: none;\n  &:hover {\n    color: ", ";\n  }\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: 0 0 1px 0.2rem rgba(0, 146, 188, 0.25);\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 500;\n  top: 0;\n  right: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n  outline: none;\n  &:hover {\n    color: ", ";\n  }\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: 0 0 1px 0.2rem rgba(0, 146, 188, 0.25);\n  }\n"])), style_utils_1.getColor("gray", 500), style_utils_1.getColor("gray", 700));
var CloseButton = function (_a) {
    var charCode = _a.charCode, closeAriaLabel = _a.closeAriaLabel, toggle = _a.toggle, props = __rest(_a, ["charCode", "closeAriaLabel", "toggle"]);
    return toggle ? (react_1.default.createElement(exports.StyledCloseButton, __assign({}, props, { type: "button", onClick: toggle, "aria-label": closeAriaLabel }),
        react_1.default.createElement("span", { "aria-hidden": "true" }, String.fromCharCode(charCode)))) : null;
};
CloseButton.defaultProps = {
    charCode: 215,
    closeAriaLabel: "Close"
};
exports.default = CloseButton;
var templateObject_1;
//# sourceMappingURL=index.js.map